module.exports = "/_next/static/images/doge-458b37ab8802be33fa5e0d94c609ee62.png";